export default "__VITE_ASSET__DAKL6eom__"